import { createFileRoute } from '@tanstack/react-router';
import { createCaslGuard } from '@/lib/auth/permissionGuards';
import { RecordingDashboardPage } from '@/pages/recording-dashboard';

export const Route = createFileRoute('/$slug/recording-dashboard/')({
  beforeLoad: createCaslGuard('RecordingDashboard'),
  component: RecordingDashboardPage
});
